<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-layout row wrap class="align-center">
      <v-flex xs10 class="pa-0 pb-2 text-xs-left">
        <div class="f-20 w-100 t-color-grey-d font-weight-bold">
          {{ cls_detail.name }}
          <span class="f-14"></span>
        </div>
        <div class="f-15 font-weight-bold ">{{ cls_detail.hours }} Minutes</div>
      </v-flex>
      <v-flex xs2 class="pb-0 text-xs-right">
        <v-btn
          small
          icon
          @click="viewcls = true"
          class="ma-0 no-shadow card-r text-primary text-capitalize"
        >
          <v-icon class="text-primary">visibility</v-icon></v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="pa-0 text-xs-center">
        <v-flex class="pa-0 ">
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-circular>
        </v-flex>
        <v-expansion-panel
          v-if="!loading"
          v-for="teacher in teacherTimes"
          class="shadow-1 mb-3 card-r practical"
          v-show="!searching"
        >
          <v-expansion-panel-content expand-icon="mdi-menu-down ">
            <!--<pre class="text-xs-left">{{studentFullClassDetails}}</pre>-->
            <template v-slot:header class="pa-0">
              <v-card class=" card-r no-shadow" color="white">
                <v-list tow-line subheader class="pa-0 transparent">
                  <v-list-tile avatar>
                    <v-list-tile-avatar size="45px" color="#077FFF">
                      <img class="objec-fit" :src="teacher[0].teacher_image" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <div class="f-15 t-color-grey-d font-weight-bold">
                        {{ teacher[0].teacher_name }}
                        <span class="font-weight-bold text-green">
                          ($ {{ teacher[0].teacher_rate }})</span
                        >
                      </div>
                      <div class="t-color-grey-l text-xs-left rate1">
                        <v-rating
                          readonly
                          x-small
                          class="pa-0 ma-0"
                          v-model="teacher[0].teacher_review"
                        ></v-rating>
                        <!--<span>Pickup location</span>-->
                      </div>
                    </v-list-tile-content>
                    <!--<v-card-actions class="pa-0">-->
                    <!--<v-btn small icon @click="viewcls = true" class= "w-100 no-shadow card-r text-primary text-capitalize">-->
                    <!--<v-icon class="text-primary">visibility</v-icon></v-btn>-->
                    <!--</v-card-actions>-->
                  </v-list-tile>
                </v-list>
              </v-card>
            </template>
            <v-card
              v-for="(clss, i) in teacher"
              :key="i"
              @click="book = true"
              class=" card-r no-shadow ma-2 grey lighten-3"
            >
              <v-list tow-line subheader class="pa-0 transparent">
                <v-list-tile avatar>
                  <!--<v-list-tile-avatar size="35px" color="#077FFF">-->
                  <!--<img class="objec-fit br-1" :src="clss.img">-->
                  <!--</v-list-tile-avatar>-->

                  <v-list-tile-content>
                    <v-list-tile-title
                      class="t-color-grey-d f-20 font-weight-bold"
                    >
                      <span class="f-16 text-primary">{{ clss.date }} </span> at
                      <span class="f-16 text-primary">
                        {{ clss.time_from }}
                      </span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="t-color-grey-l"
                      ><span class="text-grey-dark f-15">
                        {{clss.class_location}}
                        </span></v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                  <v-btn small color="primary" @click="bookClass(clss,teacher)">
                    Book
                  </v-btn>

                  <!--<v-card-actions class="pa-0">-->
                  <!--<v-btn small icon @click="viewcls = true" class= "w-100 no-shadow card-r text-primary text-capitalize">-->
                  <!--<v-icon class="text-primary">visibility</v-icon></v-btn>-->
                  <!--</v-card-actions>-->
                </v-list-tile>
              </v-list>
            </v-card>
            <v-flex class="px-2 pb-2">
              <v-btn
                class="w-100 ma-0 text-capitalize no-shadow grey lighten-1 text-white"
                round
                @click="viewMoreTime(teacher)"
              >
                Select Other Date & Time
                <!-- to="/CalenderBook" -->
              </v-btn>
            </v-flex>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>

    <v-dialog class="pa-0 border-r card-r w-100" v-model="viewcls" width="500">
      <v-card class="card-r grey lighten-4 no-shadow">
        <v-layout row xs12 justify-center>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 class="ma-2">
                <v-btn
                  small
                  icon
                  @click="viewcls = false"
                  class="right grey--text f-15"
                  ><v-icon>close</v-icon></v-btn
                >
                <div
                  class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l"
                >
                  {{ cls_detail.name }}
                </div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-container fluid grid-list-md>
              <v-card class=" no-shadow nope card-r text-xs-left pa-2">
                <v-layout xs12 row wrap class="py-2">
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Duration :</span
                    >
                    <span class="f-15 font-weight-bold text-primary"
                      >{{ cls_detail.hours }} Minutes</span
                    >
                  </v-flex>
                  <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                  <!--<span class="f-15 font-weight-bold text-grey-dark">Date: </span>-->
                  <!--<span class="f-15 font-weight-bold text-primary">2020-01-14</span>-->
                  <!--</v-flex>-->
                  <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                  <!--<span class="f-15 font-weight-bold text-grey-dark">time: </span>-->
                  <!--<span class="f-15 font-weight-bold text-primary">06:00:00</span>-->
                  <!--</v-flex>-->
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <!-- <span class="f-15 font-weight-bold text-grey-dark">Location: </span> -->
                    <!-- <span class="f-15 font-weight-bold text-primary">{{cls_detail}}</span> -->
                  </v-flex>
                  <v-flex xs12 class="text-xs-left py-0 ">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Description:</span
                    >
                    <!-- <span class="f-15 text-primary font-weight-bold pb-2">{{cls_detail}}</span> -->
                    <!--<p class="descriptionList" v-for="tag in ClassData.tags">{{tag.key}} - {{tag.description}}</p>-->
                    <p
                      v-if="index < 2"
                      v-for="(tag, index) in cls_detail.tags"
                      class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3"
                    >
                      {{ tag.key }} - {{ tag.description }}
                    </p>

                    <span v-show="read">
                      <p
                        v-if="index >= 2"
                        v-for="(tag, index) in cls_detail.tags"
                        class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3"
                      >
                        {{ tag.key }} - {{ tag.description }}
                      </p>
                    </span>
                    <v-btn
                      v-show="!read"
                      v-if="cls_detail.tags.length > 2"
                      @click="read = true"
                      class="w-100 card-r ma-0 text-capitalize no-shadow"
                      small
                      >readmore</v-btn
                    >
                    <v-btn
                      v-show="read"
                      @click="read = false"
                      class="w-100 card-r ma-0 text-capitalize no-shadow"
                      small
                      >less</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import api from "@/utils/backend-api";
/* eslint-disable */
let self;
export default {
  props: ["cls_detail", "student_id"],
  created: function() {
    self = this;
    this.getTimeByTeacher();
  },
  data() {
    return {
      loading: false,
      viewcls: false,
      searching: false,
      read: false,
      book: false,
      filtering: false,
      rating: 3,
      selectedFilter: "",
      tabs: "all",
      classTypes: [
        { text: "Teacher Name 1" },
        { text: "Teacher Name 2" },
        { text: "Teacher Name 3" }
      ],
      cards: [
        {
          name: "Teori 1",
          img:
            "https://backend.tittam.com/public/images/modules/k%C3%B8rsel.png",
          date: "2020-01-14",
          iconas: "fab fa-leanpub",
          time: "04:00pm",
          tName: "Teacher Name"
        },
        {
          name: "Teori 1",
          img: "https://i.ytimg.com/vi/asy1qhZ9Dck/maxresdefault.jpg",
          date: "2020-01-14",
          iconas: "fab fa-leanpub",
          time: "02:00pm",
          tName: "Teacher Name"
        },
        {
          name: "Teori 1",
          img: "https://backend.tittam.com/public/images/modules/glatbane.png",
          date: "2020-01-15",
          iconas: "fab fa-leanpub",
          time: "08:00am",
          tName: "Teacher Name"
        }
      ],
      teacherTimes: [],
      classData: ""
    };
  },
  methods: {
    bookClass(clss,time){
      this.viewMoreButtonStatus = false;
      let data = {
        bookType: "practical",
        times: time,
        selected:clss
      };
      this.$emit("BookClassPopup", data);
      
    },
    tempMeth(clsData) {
      console.log("clsData");
      console.log(clsData);
    },
    viewMoreTime(time) {
      this.viewMoreButtonStatus = false;
      let data = {
        bookType: "practical",
        times: time
      };
      this.$emit("viewMoreTime", data);
    },
    getTimeByTeacher() {
      self.loading = true;
      api
        .postData("booking_2/admin/getTimeByTeacher", {
          module_id: this.cls_detail.id,
          package_id: this.cls_detail.package_id,
          student_id: this.$route.params.id
        })
        .then(res => {
          self.loading = false;
          self.teacherTimes = res.data.times;
        })
        .catch(err => {
          self.loading = false;
          self.teacherTimes = [];
        });
    }
  },
  computed: {
    ...mapState({
      studentFullClassDetails: "studentFullClassDetails"
    })
  }
};
</script>
<style>
.rate1 .v-rating .v-icon {
  margin-left: 0px !important;
  padding: 2px !important;
  font-size: 19px !important;
}
.practical .v-expansion-panel__header {
  padding: 5px 10px 5px 0px !important;
}
.v-expansion-panel__container:first-child {
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/student/new/practicalbook.vue